import React from "react";
import {
	Appbar,
	BottomNavigator,
	LoginAlert,
	Overlay,
	GameAlert,
} from "@components";
import styled from "styled-components";
import HomeRoutes from "./HomeRoutes";
import { useLocation } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { IMG_HOME_BG } from "@assets";
import { NoInternet } from "@pages";

const Container = styled.div`
	min-height: 100vh;
	position: relative;
`;

const Background = styled.img.attrs({
	alt: 'homebg',
	src: IMG_HOME_BG,
})`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: auto;
max-height: 100vh;
`;

const BottomBg = styled.div`
width: 100%;
max-width: 480px;
height: 70px;
background: #004E00;
border-radius: 0;
position: fixed;
bottom: 0;
`;

const Home = () => {
	const { pathname } = useLocation();

	if (!navigator.onLine) {
		return <NoInternet />;
	}

	return (
		<>
			<Container>
				{pathname === `/${PUBLIC_ROUTE.HOME}/${PUBLIC_ROUTE.GAMES}` && (
					<>
						<Appbar />
						<Background />
						<BottomBg />
					</>
				)}
				<HomeRoutes />
				<BottomNavigator />
			</Container>
			<LoginAlert />
			<Overlay />
			<GameAlert />
		</>
	);
};

export default Home;
